module.exports = function view (state, actions) {
  return state.url ? h('img', { src: (state.getUrl()) }) : undefined
}
